/**
 * Analytics-Einwilligung (DSGVO Art. 6 Abs. 1 lit. a, TTDSG § 25).
 * Speicherung der Nutzerentscheidung ausschließlich nach aktiver, eindeutiger Handlung
 * (keine Vorauswahl, keine stillschweigende Einwilligung).
 * Weltbesten Practices: unmissverständliche Opt-In/Opt-Out-Entscheidung, dokumentierbar.
 */

const STORAGE_KEY = "takelead_analytics_consent";

export type AnalyticsConsentStatus = "accepted" | "rejected" | null;

/** Liest die gespeicherte Einwilligung. null = noch keine Entscheidung getroffen. */
export function getStoredAnalyticsConsent(): AnalyticsConsentStatus {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "accepted" || raw === "rejected") return raw;
    return null;
  } catch {
    return null;
  }
}

/**
 * Speichert die Einwilligung nur nach expliziter Nutzeraktion (TTDSG-konform).
 * Darf ausschließlich nach Klick auf "Akzeptieren" oder "Ablehnen" aufgerufen werden.
 */
export function setStoredAnalyticsConsent(status: "accepted" | "rejected"): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, status);
  } catch {
    // Best-effort
  }
}

/** Setzt gespeicherte Einwilligung zurück (z. B. für Widerruf in Einstellungen). */
export function clearStoredAnalyticsConsent(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Best-effort
  }
}
